"use strict";

var _regeneratorRuntime = require("/home/runner/work/ddctoolbox/ddctoolbox/src/website/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/home/runner/work/ddctoolbox/ddctoolbox/src/website/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/runner/work/ddctoolbox/ddctoolbox/src/website/node_modules/@babel/runtime/helpers/createClass");

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NodeFetcher = void 0;

var http_response_1 = require("../http-response");

var node_fetch_1 = __importStar(require("node-fetch"));

var NodeFetcher = /*#__PURE__*/function () {
  function NodeFetcher() {
    _classCallCheck(this, NodeFetcher);
  }

  _createClass(NodeFetcher, [{
    key: "fetch",
    value: function fetch(request) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.t0 = http_response_1.HttpResponse;
                _context.next = 3;
                return node_fetch_1.default(new node_fetch_1.Request(request.url, {
                  body: request.body,
                  headers: request.headers.toArray(),
                  method: request.method,
                  redirect: request.redirect,
                  signal: request.signal
                }));

              case 3:
                _context.t1 = _context.sent;
                _context.t2 = request;
                return _context.abrupt("return", new _context.t0(_context.t1, _context.t2));

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
    }
  }]);

  return NodeFetcher;
}();

exports.NodeFetcher = NodeFetcher;